import { useGlobalStore } from '@highlight/ipc/react'

export const useAttachmentNotifications = () => {
  const [notificationsEnabled, setNotificationsEnabled] = useGlobalStore<boolean>(
    'settings',
    'attachmentNotifications.enabled',
    true,
  )

  return {
    notificationsEnabled,
    setNotificationsEnabled,
  }
}
